export default "__VITE_ASSET__BTChV$dH__"